import React from "react";
import "../../styles/Home.scss";


const HomeLeft = () => {
  return (
    <section className="home relative">
      <div className="home-left">
        <h1 className="title"><span>Success<br/></span><span>In Motion</span></h1>
        <h2 className="subtitle">Innovate. Inspire. Impact.</h2>
        <h1 className="year">APLIC 2027</h1>
      </div>
    </section>
  );
};

export default HomeLeft;
